var _path, _path2, _g, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cash_svg__a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m35.817 60.536-2.713 4.978a.52.52 0 0 1-.444.27l-30.97.693a.52.52 0 0 1-.437-.817l6.413-9.16 5.118-8.54a.52.52 0 0 1 .694-.19L35.61 59.832a.519.519 0 0 1 .207.704Z",
    fill: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "cash_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: -8,
    width: 74,
    height: 79
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "scale(-1 1) rotate(-28.59 -11.91 173.396)",
    fill: "#D9D9D9",
    d: "M0 0h48.607v62.338H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#cash_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.506 17.773c-2.922-.543-9.74-.48-13.626 4.12l-7.352 13.49c-.588 1.08-2.928 11.7-5.609 14.089l17.018 9.274 1.911-3.507c1.358.04 4.29-.531 5.159-3.137",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.728 22.818c3.749 1.763 5.335 6.272 3.526 10.079-1.808 3.807-6.317 5.451-10.066 3.689-3.748-1.763-5.334-6.273-3.526-10.08 1.808-3.806 6.317-5.45 10.066-3.688ZM51.037 39.013c1.19.56 1.7 1.995 1.121 3.213-.578 1.217-2.016 1.738-3.207 1.178-1.19-.56-1.7-1.996-1.121-3.213.578-1.218 2.016-1.738 3.207-1.178ZM61.967 15.999c1.19.56 1.7 1.996 1.121 3.213-.578 1.218-2.017 1.738-3.207 1.178-1.191-.56-1.7-1.995-1.122-3.213.579-1.217 2.017-1.738 3.208-1.178Z",
    fill: "#E6FEE2",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.89 28.998 8.038 3.779c.677-1.125 1.329-3.876-1.478-5.888M53.028 32.598l.94-6.481M54.47 33.276l.94-6.481",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.717,
    y: 40.101,
    width: 47.913,
    height: 27.908,
    rx: 2.715,
    transform: "rotate(-56.699 26.717 40.1)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.893 35.484 51.635 8.475c.223-.338.735-.475 1.279-.342a3.9 3.9 0 0 0 3.312-.718c.438-.341.96-.418 1.3-.196l10.871 7.142c.339.223.475.733.337 1.27a3.9 3.9 0 0 0 .656 3.325c.338.447.415.97.193 1.31L51.841 47.273c-.223.339-.735.476-1.278.343a3.9 3.9 0 0 0-3.313.718c-.438.34-.96.418-1.3.195L35.08 41.39c-.34-.223-.476-.733-.337-1.27a3.9 3.9 0 0 0-.657-3.326c-.338-.446-.415-.97-.193-1.309Z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.554 21c3.695 2.427 4.701 7.44 2.23 11.202-2.47 3.76-7.47 4.828-11.165 2.4-3.695-2.427-4.702-7.44-2.231-11.201 2.47-3.76 7.471-4.828 11.166-2.4ZM46.074 36.95c1.182.776 1.509 2.384.713 3.595-.795 1.21-2.4 1.55-3.582.773-1.182-.776-1.509-2.384-.713-3.595.795-1.21 2.4-1.55 3.582-.773ZM60.965 14.284c1.181.776 1.508 2.384.713 3.595-.795 1.21-2.401 1.55-3.583.773-1.181-.776-1.508-2.384-.713-3.595.796-1.21 2.401-1.55 3.583-.773Z",
    fill: "#E6FEE2",
    stroke: "#000",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.382 26.377 7.898 5.188c.877-1.087 1.968-3.894-.688-6.437M49.103 30.497l1.945-6.703M50.517 31.426l1.945-6.702",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.72 26.369 32.745 29.99c-3.943 4.28-10.806 13.88-6.723 18.03 5.784-.486 10.66-6.903 12.375-10.05l1.24-.375c6.466-1.235 8.965-3.162 9.406-3.971 2.185-5.528-1.972-7.14-4.323-7.255Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.745 29.99 11.975-3.621c2.351.115 6.508 1.727 4.323 7.255-.441.809-2.94 2.736-9.407 3.97l-1.239.375c-1.715 3.148-6.591 9.565-12.375 10.052",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m32.96 65.778 2.857-5.242a.519.519 0 0 0-.207-.704L13.467 47.764a.52.52 0 0 0-.687.178L7.666 56l-6.5 9.778",
    stroke: "#000",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cash_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 80.167 .5)",
    d: "M0 0h80v65H0z"
  })))));
};
export default SvgCash;